import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
/**
 * Позволяет оборачиваемому элементу реализовать анимации появления/скрытия.
 *
 * Например совместо с `@renderToLayer`:
 * - после монтирования в DOM происходит анимация появления
 * - перед размонтированием - анимация скрытия
 *
 *  @renderToLayer
 *  class Popup extends Component {
 *
 *    render() {
 *      return (
 *        <VisibilityAnimation
 *          isVisible={this.props.isOpened}
 *          animationDuration={200}
 *          onVisible={this.props.onOpen}
 *          onInvisible={this.props.onClose}>
 *          {({isVisible}) => (
 *            <div className={`${css.normal} ${isVisible && css.active}`}>
 *              Some content...
 *            </div>
 *          )}
 *          {children}
 *         </VisibilityAnimation>
 *       )
 *     }
 *
 *  }
 */

var VisibilityAnimation = /*#__PURE__*/function (_PureComponent) {
  _inherits(VisibilityAnimation, _PureComponent);

  var _super = _createSuper(VisibilityAnimation);

  function VisibilityAnimation() {
    var _this;

    _classCallCheck(this, VisibilityAnimation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.status = null;
    _this.state = {
      isVisible: false
    };

    _this.show = function () {
      if (_this.status === 'showing') return;
      _this.status = 'showing';

      _this.props.onWillVisible();

      clearTimeout(_this.animationTimeout);

      _this.setState({
        isVisible: true
      });

      _this.animationTimeout = setTimeout(function () {
        _this.status = null;

        _this.props.onVisible();
      }, _this.props.animationDuration);
    };

    _this.hide = function () {
      if (_this.status === 'hiding') return;
      _this.status = 'hiding';

      _this.props.onWillInvisible();

      clearTimeout(_this.animationTimeout);

      _this.setState({
        isVisible: false
      });

      _this.animationTimeout = setTimeout(function () {
        _this.status = null;

        _this.props.onInvisible();
      }, _this.props.animationDuration);
    };

    return _this;
  }

  _createClass(VisibilityAnimation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isVisible) this.delayTimeout = setTimeout(this.show, 60);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isVisible !== this.props.isVisible) {
        clearTimeout(this.delayTimeout);
        if (this.props.isVisible) this.delayTimeout = setTimeout(this.show, 60);else this.hide();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.delayTimeout);
      clearTimeout(this.animationTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var isVisible = this.state.isVisible;
      return this.props.children({
        isVisible: isVisible
      });
    }
  }]);

  return VisibilityAnimation;
}(PureComponent);

VisibilityAnimation.defaultProps = {
  isVisible: false,
  onWillVisible: function onWillVisible() {},
  onVisible: function onVisible() {},
  onWillInvisible: function onWillInvisible() {},
  onInvisible: function onInvisible() {}
};
export { VisibilityAnimation as default };
VisibilityAnimation.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Контролирует видимость
   */
  isVisible: PropTypes.bool,

  /**
   * Таймаут для анимации в ms
   */
  animationDuration: PropTypes.number.isRequired,

  /**
   * Коллбек вызывающийся перед показом
   */
  onWillVisible: PropTypes.func,

  /**
   * Коллбек вызывающийся после показа
   */
  onVisible: PropTypes.func,

  /**
   * Коллбек вызывающийся перед скрытием
   */
  onWillInvisible: PropTypes.func,

  /**
   * Коллбек вызывающийся после скрытия
   */
  onInvisible: PropTypes.func,

  /**
   * Фабрика контента
   */
  children: PropTypes.func
} : {};